/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import history from 'utils/history';
import globalReducer from './containers/App/reducer';
import jobApplicationReducer from 'containers/JobApplication/reducer';
import jobReducer from 'containers/Job/reducer';
import footerReducer from 'shared/footer/reducer';
import modalReducer from 'shared/modal/reducer';
import vimeoReducer from 'shared/vimeo/reducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {
}) {
  const rootReducer = combineReducers({
    global: globalReducer,
    router: connectRouter(history),
    footer: footerReducer,
    modal: modalReducer,
    vimeo: vimeoReducer,
    jobApplication: jobApplicationReducer,
    job: jobReducer,
    ...injectedReducers,
  });

  return rootReducer;
}